import { render } from "./RecommendedCourseList.vue?vue&type=template&id=f8e40926"
import script from "./RecommendedCourseList.vue?vue&type=script&lang=js"
export * from "./RecommendedCourseList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__